import { io } from 'socket.io-client';

/**
 * آدرس سرور سوکت (پیش‌فرض localhost:4000)
 * می‌توان از طریق متغیر محیطی REACT_APP_SOCKET_URL مقداردهی کرد
 */
const rawSocketUrl = process.env.REACT_APP_SOCKET_URL || 'https://dev-crm.karmad.ir:4000';

// اطمینان از عدم استفاده از SSL در صورت وجود پروتکل‌های https:// یا ws// در متغیرهای محیطی
export const SOCKET_URL = rawSocketUrl;

/**
 * تنظیم فرمت Bearer توکن
 * 
 * @param {string} token 
 * @returns {string|null}
 */
export const formatBearerToken = (token) => {
  if (!token) return null;
  const trimmed = String(token).trim();
  return trimmed.startsWith('Bearer ') ? trimmed : `Bearer ${trimmed}`;
};

/**
 * تنظیمات پیش‌فرض اتصال Socket.io
 * استفاده از polling در ابتدا باعث می‌شود مرورگر بتواند هدرهای سفارشی مثل authorization را ارسال کند
 * و سپس به websocket ارتقا یابد.
 */
export const DEFAULT_SOCKET_OPTIONS = {
  transports: ['polling', 'websocket'],
  secure: false,
  autoConnect: false, // اتصال توسط Provider یا به صورت دستی مدیریت می‌شود
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
};

let globalSocket = null;

/**
 * مقداردهی یا دریافت سوکت سراسری با تنظیمات سفارشی
 * 
 * @param {string} [url=SOCKET_URL] آدرس سرور سوکت
 * @param {Object} [customOptions={}] تنظیمات اختیاری سوکت
 * @returns {import('socket.io-client').Socket} نمونه سوکت
 */
export const initializeSocket = (url = SOCKET_URL, customOptions = {}) => {
  if (!globalSocket) {
    const rawToken = localStorage.getItem('authToken');
    const bearerToken = formatBearerToken(rawToken);

    const { extraHeaders: customHeaders, auth: customAuth, ...restOptions } = customOptions;

    globalSocket = io(url, {
      ...DEFAULT_SOCKET_OPTIONS,
      ...restOptions,
      extraHeaders: {
        ...(customHeaders || {}),
        ...(bearerToken ? { authorization: bearerToken } : {}),
      },
      auth: {
        ...(customAuth || {}),
        ...(bearerToken ? { authorization: bearerToken, token: bearerToken } : {}),
      },
    });
  }
  return globalSocket;
};

/**
 * دریافت نمونه سوکت سراسری (Singleton)
 * برای استفاده در کدهای خارج از کامپوننت‌های React (سرویس‌ها، اینترسپتورها و ...)
 * 
 * @returns {import('socket.io-client').Socket}
 */
export const getSocket = () => {
  if (!globalSocket) {
    return initializeSocket();
  }
  return globalSocket;
};

/**
 * قطع اتصال و ریست سوکت سراسری
 */
export const disconnectSocket = () => {
  if (globalSocket) {
    globalSocket.disconnect();
    globalSocket = null;
  }
};

const socketConfig = {
  SOCKET_URL,
  DEFAULT_SOCKET_OPTIONS,
  formatBearerToken,
  initializeSocket,
  getSocket,
  disconnectSocket,
};

export default socketConfig;
